import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {DxTabsComponent} from "devextreme-angular";
import {MB51ChartsComponent} from "./mb51-charts/mb51-charts.component";
import {MB51DataComponent} from "./mb51-data/mb51-data.component";
import {MB51QuantitiesComponent} from "./mb51-quantities/mb51-quantities.component";
import {MB51Reason} from "@services";

@Component({
  selector: 'app-mb51',
    imports: [
        DxTabsComponent,
        MB51ChartsComponent,
        MB51DataComponent,
        MB51QuantitiesComponent
    ],
  templateUrl: './mb51.component.html'
})
export class MB51Component {
    private route = inject(ActivatedRoute);
    private router = inject(Router);

    protected readonly MB51Reason = MB51Reason;

    private readonly defaultTab = 'damage';

    tabs = [
        { text: 'Damage', id: 'damage', icon: 'fa-light fa-chart-pie' },
        { text: 'Adjustments', id: 'adjustments', icon: 'fa-light fa-chart-pie' },
        { text: 'Damage Data', id: 'damage-data', icon: 'fa-light fa-table' },
        { text: 'Adjustments Data', id: 'adjustments-data', icon: 'fa-light fa-table' },
        { text: 'All Data', id: 'all-data', icon: 'fa-light fa-database' }
    ];

    selectedTabKeys: string[] = [this.defaultTab];

    constructor() {
        this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
            const tabParam = params['tab'];
            const validTab = this.tabs.find(t => t.id === tabParam);
            this.selectedTabKeys = [validTab?.id ?? this.defaultTab];
        });
    }

    async onTabClick(id: string) {
        await this.router.navigate(['/inventory/mb51', id]);
    }
}
